<section id="{{ key }}-dialog" class="flex flex-col gap-6 p-6">
    <section
      id="{{ key }}-header"
      class="flex flex-row justify-between items-center neptune-border-b-1 border-sky-blue pb-2"
    >
      <span class="text-lg font-semibold">Add {{ implicationType }}</span>
      <div type="button" (click)="closeDialog()" class="cursor-pointer">
        <img
          alt="Close"
          src="assets/shared-icons/neptune-icon-blue-close.svg"
          class="w-6 h-6"
        />
      </div>
    </section>

    <section id="{{ key }}-form" class="flex flex-col gap-4">
      <div class="{{ key }}-notice-text text-sm">
        *Add up to 3 {{ implicationType }}
      </div>
      <form [formGroup]="editForm" (submit)="onSubmit()">
        <div
          cdkDropList
          (cdkDropListDropped)="drop($event)"
          id="dragBoundary"
          class="flex flex-col gap-6"
        >
          <div
            *ngFor="let control of implicationControls; let i = index"
            cdkDrag
          >
            <implication-edit-field
              implicationType="{{ implicationType }}"
              [formControlName]="control"
              [initialVal]="data.items[i]"
            ></implication-edit-field>
          </div>
        </div>
      </form>
    </section>

    <section
      id="{{ key }}-actions"
      class="flex flex-row justify-end gap-4 pt-4 neptune-border-t-2 border-neptune-border-subtle"
    >
      <div class="flex flex-row justify-end gap-6">
        <button
          id="{{ key }}-reset-button"
          type="button"
          (click)="resetValues()"
          class="neptune-button-white min-w-24"
        >
          Reset
        </button>
        <button
          id="{{ key }}-submit-button"
          type="submit"
          (click)="onSubmit()"
          class="neptune-button-blue min-w-24"
        >
          Submit
        </button>
      </div>
    </section>
  </section>
